import React, {useEffect, useState} from 'react';

//dialogs
import ShowProject from './components/dialogs/ShowProject';

const color = [
  {  bgColor: 'bg-pink-600' },
  {  bgColor: 'bg-purple-600' },
  {  bgColor: 'bg-yellow-500' },
  {  bgColor: 'bg-green-500' },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const PinnedProjects = ({allUserMsg}) => {

  const [ allProjects, setAllProjects ] = useState()
  const [ openAddTask, setOpenAddTask ] = useState(false)
  const [ saveProject, setSaveProject ] = useState()

  useEffect(() => {
    // const countProjects = () => {
    //     var arr = [];
    //     allUserMsg?.map(projects =>{
    //         if(projects.ContentCreated){
    //           projects.ContentCreated.slice().reverse().map(project => {
    //                 return arr.push(project)
    //             })
    //             console.log(arr);
    //             return arr
    //         }else { 
    //             return null
    //         }
    //     })
    //     mergeObjects( arr.slice(0,4), color.slice(-arr.slice(-4)))
    // }
    var arr = allUserMsg.slice(0,4)
    var arrColor = color.slice(-allUserMsg.slice(-4))

    function mergeObjects(arr1,arr2){
      var arrB = []
      return arr1.map((item,i)=>{
         if(item.id !== arr2[i].id){ //if(item.id === arr2[i].id){
             arrB.push( Object.assign({},item,arr2[i])) 
         }
         return setAllProjects(arrB)
      })
    }
    mergeObjects(arr, arrColor)
    //countProjects()
  }, [allUserMsg])

  const handleClick = (project) => {
    setOpenAddTask(true)
    setSaveProject(project)
  }
  return (
    <div>
      <h2 className="text-gray-500 text-xs font-medium uppercase tracking-wide mt-10">Last 4 Saved Messages</h2>
      {allProjects?.length > 0 ? 
      <div>
      <ul className="mt-3 grid grid-cols-1 gap-5 sm:gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {allProjects?.map((project, index) => (
          // console.log(project)
          <li key={index} className="col-span-1 flex shadow-sm rounded-md">
            <div
              className={classNames(
                project.bgColor,
                'flex-shrink-0 flex items-center justify-center w-32 h-20 text-white text-sm font-medium rounded-l-md p-4'
              )}
            >
              {/* {project.ProspectInterestUsed} */}
              {project?.InterestUsed?.activity_status?.length > 0 ?
              <span>
                Recent Linkedin Activity
              </span>
              :
              <span>
              {project?.InterestUsed}
              </span>
              }
            </div>
            <div className="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate">
              <div className="flex-1 px-4 py-2 text-sm truncate">
                {/* <a href={project.href} className="text-gray-900 font-medium hover:text-gray-600">
                  {project.name}
                </a> */}
                {/* <p className="text-gray-500">{project.likes} likes</p> */}
              </div>
              <div className="flex-shrink-0 pr-2">
                <button
                type="button"
                className="inline-flex items-center shadow-sm px-2.5 py-0.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50"
                onClick={()=> handleClick (project) }
                >
                View
                </button>
              </div>
            </div>
          </li>
        ))}
      </ul>
      {openAddTask ? 
        <ShowProject open={openAddTask} setOpen={setOpenAddTask} saveProject={saveProject}/> 
      : 
        null
      }
      </div>
      :
      <div className="text-gray-400 text-lg text-center border-4 mt-2 font-semibold border-gray-300 border-dashed p-6 rounded-lg">
        Last 4 Fire Messages Go Here
      </div>
      }
    </div>
  )
}

export default PinnedProjects